import { translate } from 'i18n/i18n'
import moment from 'moment-timezone'
import { AlertFrequencyWording } from './AlertFrequencyWording/AlertFrequencyWording'
import { ScheduleWording } from './ScheduleWording/ScheduleWording'
import { SleepWording } from './SleepWording/SleepWording'

export const FrequencyAndScheduling = ({
  sleepMinutes,
  frequencyMinutes,
  startDate,
  endDate,
  hourOfDay,
}: {
  sleepMinutes: number | null
  frequencyMinutes: number | null
  startDate: string | null
  endDate: string | null
  hourOfDay?: string
}) => {
  const hasScheduling = startDate && endDate

  const hourOfDayString =
    hourOfDay &&
    moment.tz().startOf('year').add(hourOfDay, 'hours').format(translate.dates.getMomentFormat('h:mm a'))

  return (
    <div>
      <AlertFrequencyWording frequencyMinutes={frequencyMinutes} />
      {sleepMinutes && (
        <>
          {', '}
          <SleepWording sleepMinutes={sleepMinutes} />
        </>
      )}
      {', '}
      {!!hourOfDayString && translate.phrases.banyanApp('at around {{hourOfDayString}}', { hourOfDayString })}
      {!!hourOfDayString && ', '}
      {hasScheduling ? (
        <ScheduleWording startDate={startDate} endDate={endDate} />
      ) : (
        <>{translate.phrases.banyanApp('year-round')}</>
      )}
    </div>
  )
}
